import {ActionTree} from 'vuex';
import {DI, getDIContainer} from '@/brief-hub/config/DependencyInjection';
import {MutationsType} from './mutations';
import {ConnectedUserState} from './types';
import {StoreState} from '@/brief-hub/store/state/StoreState';

export enum ActionsType {
    GET_CONNECTED_USER = 'getConnectedUser',
}

export const actions: ActionTree<ConnectedUserState, StoreState> = {
    [ActionsType.GET_CONNECTED_USER]: ({commit}) => {
        return getDIContainer()
            [DI.userService].get()
            .then((data) => commit(MutationsType.UPDATE_CONNECTED_USER, data[0]));
    },
};
